import { Routes } from "../Shared/components/Navigation/navigationUtils";
/**
 * Navigate to checkout with gift card data in location state
 * @param navigate
 * @returns
 */
export const giftCardFormSubmit = (navigate) => (data) => {
    navigate({
        pathname: Routes.GIFT_CARD_CHECKOUT,
    }, {
        state: {
            giftCardState: {
                amount: data.giftCardAmount,
                fromFirstName: data.fromFirstName,
                fromLastName: data.fromLastName,
                toFirstName: data.toFirstName,
                toLastName: data.toLastName,
                message: data.message,
                email: data.toEmail,
                deliveryDate: data.deliveryDate,
            },
        },
    });
};
